// extracted by mini-css-extract-plugin
export default {"actions":"CreateSurveyActionButtons_actions__7YgCK","rightActions":"CreateSurveyActionButtons_rightActions__iQMoK"};